import { Swiper, SwiperSlide } from 'swiper/react'
import { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import SwiperCore, { Navigation, Pagination } from 'swiper'
import { useTranslation } from 'next-i18next'

// Internal components
import Button from '../Button/Button'
import { UserContext } from '../../context/UserContext'

const ModalOnboarding = (props) => {
  const { slides, buttons } = props
  const [onboardingStep, setOnboardingStep] = useState(1)
  const onMobile = window.innerWidth < 460
  const userContext = useContext(UserContext)
  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const createMarkup = (copy) => ({ __html: copy })

  SwiperCore.use([Navigation, Pagination])
  return (
    <div className="ModalOnboarding">
      <Swiper
        key="123"
        slidesPerView={1}
        className={'ModalOnboarding-swiper'}
        slideClass={'ModalOnboarding-swiperSlide'}
        pagination={{
          el: '.ModalOnboarding-pagination',
          type: 'bullets',
          clickable: true,
          bulletClass: 'ModalOnboarding-bullet',
          bulletActiveClass: 'is-active'
        }}
        navigation={{
          prevEl: '.Button--modalOnboardingPrev',
          nextEl: '.Button--modalOnboardingNext'
        }}
        onSlideChangeTransitionStart={(event) => {
          setOnboardingStep(event.activeIndex + 1)
        }}
      >
        <div className="ModalOnboarding-SwiperContent">
          {slides &&
            slides.map((slide, index) => {
              const { image, alt, title, description } = slide
              return (
                <SwiperSlide className="ModalOnboarding-swiperSlide" key={`ModalOnboarding-Swiperslide--${index}}`}>
                  <img
                    className="ModalOnboarding-image"
                    src={onMobile ? image?.mobile?.path : image?.desktop?.path}
                    loading="lazy"
                    alt={t(alt)}
                  />
                  <h3 className="ModalOnboarding-title">{t(title)}</h3>
                  <p className="ModalOnboarding-description" dangerouslySetInnerHTML={createMarkup(t(description))}></p>
                </SwiperSlide>
              )
            })}
        </div>
      </Swiper>
      <div
        className={`ModalOnboarding-navigation ${
          onboardingStep === slides.length && buttons?.link && buttons?.close
            ? 'ModalOnboarding-navigation--dialog'
            : ''
        }`}
      >
        {buttons?.previous && (
          <Button
            label={!onMobile ? t(buttons?.previous?.label) : ''}
            modifiers={['Button--modalOnboarding', 'Button--modalOnboardingPrev']}
            icon={{ id: 'icon-chevron-left' }}
          />
        )}
        {slides.length >= 2 && (
          <div
            className={`ModalOnboarding-pagination${onboardingStep === slides.length && onMobile ? ' is-hidden' : ''}`}
          ></div>
        )}
        {buttons?.next && (
          <div className={`ModalOnboarding-nextWrapper${onboardingStep === slides.length ? ' is-hidden' : ''}`}>
            <Button
              label={!onMobile ? t(buttons?.next?.label) : ''}
              modifiers={['Button--modalOnboarding', 'Button--modalOnboardingNext']}
              icon={{ id: 'icon-chevron-right' }}
            />
          </div>
        )}
        {onboardingStep === slides.length && buttons?.last && (
          <Button
            label={t(buttons?.last?.label)}
            modifiers={['Button--modalOnboarding', 'Button--modalOnboardingProceed']}
            icon={{ id: 'icon-chevron-right' }}
            modal={buttons?.last?.modal}
          />
        )}
        {onboardingStep === slides.length && buttons?.close && (
          <Button
            label={t(buttons?.close?.label)}
            modifiers={['Button--modalOnboarding', 'Button--modalOnboardingText']}
            modal={buttons?.close?.modal}
          />
        )}
        {onboardingStep === slides.length && buttons?.link && (
          <Button
            label={t(buttons?.link?.label)}
            href={buttons?.link?.href}
            target={buttons?.link?.target}
            hook={buttons?.link?.hook}
            modifiers={['Button--modalOnboarding', 'Button--modalOnboardingProceed']}
            icon={buttons?.link?.icon}
          />
        )}
      </div>
    </div>
  )
}

ModalOnboarding.propTypes = {
  slides: PropTypes.array,
  buttons: PropTypes.object
}

export default ModalOnboarding
